
import React from "react";
import { LucideIcon } from "lucide-react";

interface LegalHeroProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  date: string;
}

const LegalHero = ({ title, subtitle, icon, date }: LegalHeroProps) => {
  return (
    <section className="relative py-16 md:py-24 bg-gradient-to-b from-elfGreen-light to-elfGreen-light/60 overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[url('/patterns/elf-pattern.svg')] bg-repeat"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center p-3 mb-6 bg-white rounded-full shadow-md">
            {icon}
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 text-elfRed">{title}</h1>
          <p className="text-xl text-gray-700 mb-4">{subtitle}</p>
          <div className="flex items-center justify-center gap-2 text-lg md:text-xl mt-6 bg-white/80 py-2 px-4 rounded-full inline-flex mx-auto">
            <p className="font-medium">Effective Date: {date}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalHero;
